import { IAbstractComputationNode } from '../computation.types';
import { ExpressionNodeTree } from './computation-tree.types';

/**
 *  Pre-order tree traversal visits each node using stack.
 *  Checks if leaf node is not an array otherwise
 *  pushes all nodes into stack and continues traversal.
 *  @param {ExpressionNodeTree} root - expression tree to add
 *  @returns array  - final array of nodes in order
 */
export function convertExpressionTreeToNodeList<
  T extends IAbstractComputationNode
>(root: ExpressionNodeTree<T>) {
  const nodeList: T[] = [];

  for (const node of root) {
    if (!Array.isArray(node)) {
      nodeList.push(node);
    } else {
      nodeList.push(...convertExpressionTreeToNodeList(node));
    }
  }

  return nodeList;
}

/**
 *  @param {T[]} nodeList - a list of nodes
 *  @returns {ExpressionNodeTree} tree  - tree structure of an array of nodes or nodes[]
 */
export function convertNodeListToExpressionTree<
  T extends IAbstractComputationNode
>(nodes: T[], index = 0, initialNode?: T) {
  const tree: ExpressionNodeTree<T> = [];

  if (initialNode) {
    tree.push(initialNode);
  }
  let nodeIndex = index;
  while (nodeIndex < nodes.length) {
    const node = nodes[nodeIndex];

    if (node.isStartBracket()) {
      const resultTree = convertNodeListToExpressionTree(
        nodes,
        nodeIndex + 1, //index to start sub group
        node
      );

      tree.push(resultTree);

      nodeIndex++;

      // get total flattened arrays length
      nodeIndex += resultTree.flat(6).length - 1;
    } else {
      tree.push(node);
      nodeIndex++;
      if (node.isCloseBracket()) {
        return tree;
      }
    }
  }

  return tree;
}
